<template>
  <div>
    <ed-modal
      title="Enviar Orçamento por Email"
      :modal="showFormEmail"
      :loadingSave="loadingTable"
      :onSave="proposta"
      width="95%"
    >
      <div slot="modal-content">
        <ed-form
          :data="formData"
          :config="config"
          :response="response"
          :itens="formItems"
        >
          <div slot="form-footer"></div>
        </ed-form>
      </div>
    </ed-modal>

    <b-table-simple
      id="table-v0"
      class="table-v2 mt-1"
      small
      outlined
      borered
      v-loading="loadingTable"
    >
      <b-thead>
        <b-tr>
          <b-th>DESCRIÇÃO</b-th>
          <b-th width="200">QUANTIDADE</b-th>
          <b-th width="200">VALOR (R$)</b-th>
          <b-th width="150">ATUALIZAÇÃO</b-th>
          <b-th width="150"></b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr>
          <b-td
            colspan="5"
            style="background: #f9f6db; font-weight: bold; height: 40px"
          >
            <ed-button icon="fa fa-usd" type="text" />
            CUSTO DAS MEDIÇÕES
          </b-td>
        </b-tr>
        <b-tr v-for="(data, i) in formData.servicosMedicao" :key="i + 1000">
          <b-td
            valign="middle"
            :style="
              'font-size:7.5pt !important;background:' +
              (i % 2 == 0 ? '#E6E6E6' : '')
            "
          >
            {{ data.nome }}
          </b-td>
          <b-td
            valign="middle"
            :style="
              'font-size:7.5pt !important;background:' +
              (i % 2 == 0 ? '#E6E6E6' : '')
            "
          >
            {{ data.total }}
          </b-td>
          <b-td
            valign="middle"
            :style="
              'font-size:7.5pt !important;background:' +
              (i % 2 == 0 ? '#E6E6E6' : '')
            "
          >
            {{ data.valor_venda }}
            <span
              v-if="
                response.options &&
                response.options.data &&
                response.options.data[data.id]
              "
              style="color: red"
            >
              <br />{{ response.options.data[data.id][0] }}
            </span>
          </b-td>
          <b-td
            valign="middle"
            :style="
              'font-size:7.5pt !important;background:' +
              (i % 2 == 0 ? '#E6E6E6' : '')
            "
          >
            ---
          </b-td>
          <b-td
            valign="middle"
            :style="
              'font-size:7.5pt !important;background:' +
              (i % 2 == 0 ? '#E6E6E6' : '')
            "
          >
            ---
          </b-td>
        </b-tr>
        <b-tr>
          <b-td style="background: #deeef9; font-weight: bold; height: 40px">
            TOTAL MEDIÇÕES
          </b-td>
          <b-td style="background: #deeef9; font-weight: bold">
            {{ formData.qtde_medicao }}
          </b-td>
          <b-td style="background: #deeef9; font-weight: bold">
            {{ formData.valor_medicao }}
          </b-td>
          <b-td style="background: #deeef9; font-weight: bold"></b-td>
          <b-td style="background: #deeef9; font-weight: bold"></b-td>
        </b-tr>
        <b-tr>
          <b-td
            colspan="4"
            style="background: #f9f6db; font-weight: bold; height: 40px"
          >
            <ed-button icon="fa fa-usd" type="text" />
            CUSTOS DOS SERVIÇOS
          </b-td>
          <b-td style="background: #f9f6db; font-weight: bold">
            <ed-button
              icon="fa fa-plus-circle"
              type="text"
              title="Inserir Novo Serviço"
              value="Inserir Novo Serviço"
              @click="onRegister()"
            />
          </b-td>
        </b-tr>
        <b-tr v-for="(data, i) in formData.servicos" :key="i">
          <b-td
            valign="middle"
            :style="
              'font-size:7pt !important;background:' +
              (i % 2 == 0 ? '#E6E6E6' : '')
            "
          >
            <el-input v-model="data.descricao" type="text" />
          </b-td>
          <b-td
            valign="middle"
            :style="
              'font-size:7pt !important;background:' +
              (i % 2 == 0 ? '#E6E6E6' : '')
            "
          >
            <el-input
              v-model="data.qtde"
              @change="formataCustoServicos"
              type="number"
            />
          </b-td>
          <b-td
            valign="middle"
            :style="
              'font-size:7pt !important;background:' +
              (i % 2 == 0 ? '#E6E6E6' : '')
            "
          >
            <el-input
              v-model="data.valor"
              @change="formataCustoServicos"
              v-mask="'money'"
              type="text"
            />
          </b-td>
          <b-td
            valign="middle"
            :style="
              'font-size:7pt !important;background:' +
              (i % 2 == 0 ? '#E6E6E6' : '')
            "
          >
            <div v-if="data.usuario">
              {{ data.usuario.usuario }}<br />
              {{ toDate(data.updated_at) }}
            </div>
          </b-td>
          <b-td
            valign="middle"
            :style="
              'font-size:7pt !important;background:' +
              (i % 2 == 0 ? '#E6E6E6' : '')
            "
          >
            <ed-button
              v-if="data.padrao == 0"
              icon="fa fa-trash"
              type="danger"
              size="mini"
              title="Deletar Registro"
              @click="onDelete(i)"
            />
          </b-td>
        </b-tr>
        <b-tr>
          <b-td style="background: #deeef9; font-weight: bold; height: 40px">
            TOTAL SERVIÇOS
          </b-td>
          <b-td style="background: #deeef9; font-weight: bold">
            {{ formData.qtde_servico }}
          </b-td>
          <b-td style="background: #deeef9; font-weight: bold">
            {{ formData.valor_servico }}
          </b-td>
          <b-td style="background: #deeef9; font-weight: bold"></b-td>
          <b-td style="background: #deeef9; font-weight: bold"></b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>

    <div
      class="col-12 text-right d-flex flex-row-reverse bd-highlight"
      style="padding: 0 !important"
    >
      <div
        class="col-xs-12 text-center col-sm-12 col-md-6 col-lg-5 col-xl-4"
        style="padding: 0 !important"
      >
        <b-table-simple
          id="table-v0"
          class="table-v2 mt-1"
          small
          outlined
          borered
          v-loading="loadingTable"
        >
          <b-thead>
            <b-tr>
              <b-th colspan="2">CUSTO TOTAL</b-th>
            </b-tr>
          </b-thead>
          <b-tr>
            <b-td style="color: #dd5a5a; font-weight: bold; text-align: left">
              DESCONTOS
            </b-td>
            <b-td style="color: #dd5a5a; font-weight: bold; text-align: left">
              <el-input
                v-model="formData.valor_desconto"
                v-mask="'money'"
                type="text"
                @change="formataCustoTotal"
              />
            </b-td>
          </b-tr>
          <b-tr>
            <b-td
              colspan="2"
              style="
                font-weight: bold;
                text-align: right;
                font-size: 18px !important;
              "
            >
              Custo Total
              <span style="color: #699e62">R$ {{ formData.valor_total }}</span>
            </b-td>
          </b-tr>
          <b-tr>
            <b-td
              colspan="2"
              style="
                font-weight: bold;
                text-align: right;
                font-size: 18px !important;
              "
            >
              Lucro Líquido
              <span style="color: #699e62">R$ {{ formData.valor_lucro }}</span>
              <span style="color: #699e62; font-size: 15px !important"
                >({{ formData.percent_lucro }}%)</span
              >
            </b-td>
          </b-tr>
        </b-table-simple>
      </div>
    </div>

    <div class="col-12 text-center">
      <ed-button
        icon="fa fa-floppy-o"
        type="primary"
        value="Salvar Orçamento"
        @click="salvar"
      />

      <ed-button
        icon="fa fa-search-plus"
        type="warning"
        value="Prévia do Orçamento"
        @click="previa"
      />

      <ed-button
        icon="fa fa-paper-plane"
        type="success"
        value="Enviar Orçamento"
        @click="showFormEmail = !showFormEmail"
      />
    </div>
  </div>
</template>

<script>
import EdButton from "common/button";
import EdModal from "common/modal";
import EdForm from "common/form";
import Rest from "common/rest";
import FormItems from "./_form/orcamento-email";

export default {
  name: "exame",
  components: { EdButton, EdModal, EdForm },
  mixins: [Rest],
  props: {
    orcamento: {
      type: Object,
      default: null,
    },
  },
  watch: {
    "orcamento.id"() {
      this.inicialize();
    },
  },
  computed: {},
  data() {
    return {
      config: {
        click: {
          id_conta_email: this.getContaEmail,
        },
        list: {
          id_conta_email: [],
        },
        loading: {
          id_conta_email: false,
        },
      },
      pagination: {},
      response: {},
      formData: {
        id_conta_email: null,
        destinatario: null,
        mensagem: null,
        pdf: null,
        forma_pagamento: null,
        qtde_medicao: 0,
        valor_medicao: 0,
        qtde_servico: 0,
        valor_servico: 0,
        valor_desconto: "0,00",
        valor_total: "0,00",
        valor_lucro: "0,00",
        percent_lucro: "0,00",
        servicos: [],
      },
      loadingTable: false,
      showFormEmail: false,
      formItems: [],
    };
  },

  created() {
    this.formItems = FormItems;
  },

  mounted: function () {
    this.getLtcatOrcamentoServico();
    this.getLtcatOrcamentoMedicaoResumo();
    this.getContaEmail();
    this.inicialize();

    this.$events.on("orcamentoMedicao." + this.orcamento.id, (eventData) => {
      this.getLtcatOrcamentoMedicaoResumo();
    });

    this.$events.on("ckeditor-mensagem", (eventData) => {
      this.formData.mensagem = eventData;
    });

    this.$events.on("ckeditor-pdf", (eventData) => {
      this.formData.pdf = eventData;
    });
  },

  methods: {
    inicialize() {
      if (this.orcamento) {
        this.formData.mensagem = this.orcamento.mensagem;
        this.formData.destinatario = this.orcamento.empresa
          ? this.orcamento.empresa.email
          : null;
        this.formData.valor_desconto = this.orcamento.valor_desconto;
        this.formData.pdf = this.orcamento.pdf;
      }
    },

    onRegister() {
      this.formData.servicos.push({
        id: 0,
        descricao: null,
        qtde: 1,
        padrao: 0,
        valor: "0,00",
        usuario: null,
      });
      this.formataCustoServicos();
    },

    onDelete(index) {
      this.formData.servicos.splice(index, 1);
      this.formataCustoServicos();
    },

    getContaEmail: function (_search) {
      this.config.list.id_conta_email = [];
      this.config.loading.id_conta_email = true;

      this.get("conta-email", {
        search: _search,
      }).then((result) => {
        result = result[0];
        this.config.loading.id_conta_email = false;

        if (result.status == 200) {
          this.config.list.id_conta_email = result.data.data;
        }
      });
    },

    getLtcatOrcamentoServico(_search, _page, _pagination) {
      if (!this.$store.state.ltcat.data) return;

      this.loadingTable = true;
      this.response = {};
      this.formData.servicos = [];

      this.get("ltcat/orcamento/servico/" + this.orcamento.id, {
        search: _search,
        page: _page,
        pagination: 100,
      }).then((result) => {
        result = result[0];
        this.response = result;
        this.loadingTable = false;

        if (result.status == 200) {
          this.formData.servicos = result.data.data;
          this.formataCustoServicos();
        }
      });
    },

    getLtcatOrcamentoMedicaoResumo() {
      if (!this.$store.state.ltcat.data) return;

      this.loadingTable = true;
      this.response = {};
      this.formData.servicosMedicao = [];

      this.get("ltcat/orcamento/medicao/" + this.orcamento.id + "/resumo").then(
        (result) => {
          result = result[0];
          this.response = result;
          this.loadingTable = false;
          if (result.status == 200) {
            this.formData.servicosMedicao = result.data;
            this.formataCustoMedicoes();
          }
        }
      );
    },

    formataCustoMedicoes() {
      var qtde = 0,
        valor = 0,
        self = this;

      this.formData.servicosMedicao.forEach(function (objMedicao) {
        qtde += parseInt(objMedicao.total);
        valor += self.moneyToFloat(objMedicao.valor_venda);
      });

      this.formData.qtde_medicao = qtde;
      this.formData.valor_medicao = this.floatToMoney(valor);

      this.formataCustoTotal();
    },

    formataCustoServicos() {
      var qtde = 0,
        valor = 0,
        self = this;

      this.formData.servicos.forEach(function (objServico) {
        qtde += parseInt(objServico.qtde);
        valor += self.moneyToFloat(objServico.valor);
      });

      this.formData.qtde_servico = qtde;
      this.formData.valor_servico = this.floatToMoney(valor);

      this.formataCustoTotal();
    },

    formataCustoTotal() {
      var valor_medicao = this.moneyToFloat(this.formData.valor_medicao),
        valor_servico = this.moneyToFloat(this.formData.valor_servico),
        valor_desconto = this.moneyToFloat(this.formData.valor_desconto),
        valor_total = valor_medicao + valor_servico - valor_desconto,
        valor_lucro = valor_medicao - valor_servico - valor_desconto,
        percent_lucro = (valor_lucro / valor_total) * 100;

      if (valor_desconto && valor_desconto > valor_lucro) {
        this.edAlert(
          "O valor de desconto não pode ser maior que o lucro líquido",
          "warning"
        );
        this.formData.valor_desconto = "0,00";
        return;
      }

      this.formData.valor_total = this.floatToMoney(valor_total);
      this.formData.valor_lucro = this.floatToMoney(valor_lucro);
      this.formData.percent_lucro = this.floatToMoney(percent_lucro);
    },

    validar_formulario() {
      let erro = "";
      this.formData.servicos.forEach(function (objServico) {
        if (!objServico.descricao) {
          erro = "Favor preencher a descrição de todos os campos";
        }
      });

      if (erro) {
        this.edAlert(erro, "danger");
        return false;
      }

      return true;
    },

    salvar() {
      if (this.validar_formulario()) {
        this.loadingTable = true;
        this.response = {};

        this.post(
          "ltcat/orcamento/servico/" + this.orcamento.id + "/editar",
          this.formData
        ).then((result) => {
          result = result[0];
          this.response = result;
          this.loadingTable = false;

          if (result.status == 200) {
            this.edMsg("Dados atualizados com sucesso");
            this.getLtcatOrcamentoServico();
          }
        });
      }
    },

    proposta() {
      if (this.validar_formulario()) {
        this.loadingTable = true;
        this.response = {};

        this.post(
          "ltcat/orcamento/servico/" + this.orcamento.id + "/enviar-proposta",
          this.formData
        ).then((result) => {
          result = result[0];
          this.response = result;
          this.loadingTable = false;

          if (result.status == 200) {
            this.showFormEmail = !this.showFormEmail;
            this.edMsg("Dados atualizados com sucesso");
            this.getLtcatOrcamentoServico();

            this.$events.fire("orcamentoProposta", []);
          }
        });
      }
    },

    previa(method) {
      this.open("ltcat/orcamento/servico/" + this.orcamento.id + "/previa");
    },
  },
};
</script>


// WEBPACK FOOTER //
// servico.vue?7af67a0a